/*
 * Fuente única de datos de productos.
 *
 * IMPORTANTE: este archivo usa CommonJS (module.exports) a propósito, para que
 * lo puedan consumir DOS entornos sin duplicar contenido:
 *   - El frontend React:  import products from '../../Data/products'
 *   - El servidor Express: require('./src/Data/products')  (inyección de SEO)
 *
 * No agregar JSX ni imports de React aquí: solo datos planos.
 */

const products = [
    {
        slug: 'wp-ai-studio',
        name: 'WP AI Studio',
        img: 'wpai-studio.svg',
        status: 'En producción',
        featured: true,
        liveUrl: 'https://wpai-studio.fly.dev/',
        tagline: 'Chatbots de WhatsApp con IA que atienden a tus clientes 24/7',
        pitch: 'SaaS de chatbots con IA para WhatsApp Business. Atiende clientes 24/7 con texto y notas de voz, entrenado con la información de tu negocio.',
        intro: 'WP AI Studio es una plataforma SaaS para crear y operar chatbots de WhatsApp con inteligencia artificial. Cada bot se entrena con la información real de tu negocio y responde tanto en texto como en notas de voz, de forma natural y disponible las 24 horas.',
        problem: 'Los clientes escriben a cualquier hora y esperan respuesta inmediata. Contestar manualmente todos los mensajes es imposible de escalar: se pierden ventas por demoras, preguntas repetidas y horarios sin cobertura.',
        solution: 'Un asistente de IA entrenado con tu catálogo, precios y preguntas frecuentes responde al instante en WhatsApp, entiende audios, resuelve las dudas comunes y escala a un asesor humano solo cuando de verdad hace falta.',
        features: [
            'Bots entrenables con base de conocimiento (RAG)',
            'Responde audios con voz sintetizada (STT/TTS)',
            'Escalación automática a asesor humano en vivo',
            'Panel con métricas y control de consumo',
        ],
        useCases: [
            'Atención al cliente y soporte de primer nivel automatizado',
            'Calificación y captura de leads directamente en WhatsApp',
            'Respuesta a preguntas frecuentes sobre productos y precios',
            'Agendamiento y seguimiento de solicitudes',
        ],
        stack: ['IA', 'WhatsApp', 'n8n', 'OpenAI', 'SaaS'],
        tags: ['IA', 'WhatsApp', 'n8n', 'OpenAI', 'SaaS'],
        seo: {
            title: 'WP AI Studio — Chatbots de WhatsApp con IA 24/7',
            description: 'SaaS de chatbots con IA para WhatsApp Business. Atiende clientes 24/7 con texto y notas de voz, entrenado con la información de tu negocio. Escalación a humano, RAG y métricas.',
        },
    },
    {
        slug: 'call-bot-ia',
        name: 'Call Bot IA',
        img: 'callbot.svg',
        status: 'En producción',
        featured: false,
        liveUrl: null,
        tagline: 'Un agente de voz que llama a tus leads y los califica por ti',
        pitch: 'Agente de voz que llama a tus leads, los saluda con voz natural, hace preguntas de calificación y decide si son clientes viables.',
        intro: 'Call Bot IA es un agente de voz que realiza llamadas salientes con una voz natural, conversa con tus prospectos, hace las preguntas clave de calificación y determina qué tan viable es cada lead antes de pasarlo a tu equipo comercial.',
        problem: 'Llamar uno por uno a cada lead para saber si tiene presupuesto, urgencia e interés consume horas del equipo comercial, y la mayoría de esas llamadas terminan en prospectos que nunca iban a comprar.',
        solution: 'El agente de voz IA hace ese primer filtro automáticamente: llama, conversa, califica según presupuesto, plazo e interés, deja transcripción con tags, y hace seguimiento por WhatsApp al colgar. Tu equipo solo habla con leads ya filtrados.',
        features: [
            'Llamadas salientes con voz conversacional IA',
            'Califica leads: presupuesto, plazo e interés',
            'Transcripción completa y tags automáticos',
            'Seguimiento automático por WhatsApp al colgar',
        ],
        useCases: [
            'Precalificación de leads para equipos comerciales',
            'Confirmación de citas y recordatorios por voz',
            'Encuestas y sondeos telefónicos automatizados',
            'Reactivación de bases de datos de contactos fríos',
        ],
        stack: ['Voz IA', 'Twilio', 'ElevenLabs', 'OpenAI', 'CRM'],
        tags: ['Voz IA', 'Twilio', 'ElevenLabs', 'CRM'],
        seo: {
            title: 'Call Bot IA — Agente de voz que llama y califica leads',
            description: 'Agente de voz con IA que llama a tus leads, conversa con voz natural, los califica por presupuesto, plazo e interés, y hace seguimiento por WhatsApp. Transcripción y tags automáticos.',
        },
    },
    {
        slug: 'seriaccess',
        name: 'Seriaccess',
        img: 'seriasses.svg',
        status: 'En producción',
        featured: false,
        liveUrl: 'https://seriaccess.fly.dev/',
        tagline: 'Control de ingreso de personal con huella digital, sin planillas',
        pitch: 'Sistema de control de ingreso y salida de personal con lector de huella. Registro biométrico confiable, sin planillas ni suplantación.',
        intro: 'Seriaccess es un sistema de control de acceso y asistencia con lector de huella digital. Registra entradas y salidas de personal de forma biométrica, eliminando planillas de papel, tarjetas prestadas y la suplantación en el marcaje.',
        problem: 'Las planillas de papel y las tarjetas se prestan, se pierden y se falsifican. Sin un registro confiable de entradas y salidas, calcular horas trabajadas y controlar la asistencia se vuelve un problema de confianza y de tiempo.',
        solution: 'Con el lector de huella cada persona se identifica en segundos de forma inequívoca. El sistema guarda el historial, genera reportes de asistencia y elimina la suplantación, ideal para empresas, conjuntos residenciales y obras.',
        features: [
            'Registro de entradas y salidas con huella digital',
            'Identificación biométrica en segundos',
            'Historial y reportes de asistencia',
            'Ideal para empresas, conjuntos y obras',
        ],
        useCases: [
            'Control de asistencia laboral en empresas',
            'Ingreso de personal y contratistas en obras',
            'Acceso de residentes y visitantes en conjuntos',
            'Reportes de horas trabajadas para nómina',
        ],
        stack: ['Biometría', 'WebUSB', 'Node.js', 'Reportes'],
        tags: ['Biometría', 'Control de acceso', 'Reportes'],
        seo: {
            title: 'Seriaccess — Control de acceso y asistencia con huella digital',
            description: 'Sistema de control de ingreso y salida de personal con lector de huella. Registro biométrico confiable, sin planillas ni suplantación. Historial y reportes de asistencia.',
        },
    },
    {
        slug: 'monitor-oro-plata',
        name: 'Monitor Oro & Plata',
        img: 'oro.svg',
        status: 'En producción',
        featured: false,
        liveUrl: null,
        tagline: 'Cotización de oro y plata en tiempo real, en COP por gramo',
        pitch: 'Sistema de cotización en tiempo real de oro y plata para comerciantes colombianos. API central que scrapea múltiples fuentes, convierte a COP/gramo por pureza y alimenta 3 frontends PWA independientes.',
        intro: 'Monitor Oro & Plata es un sistema de cotización en tiempo real de metales preciosos pensado para comerciantes colombianos. Una API central scrapea varias fuentes, convierte los precios a pesos colombianos por gramo según la pureza y alimenta tres frontends PWA independientes.',
        problem: 'El precio internacional del oro y la plata cambia constantemente y viene en onzas y dólares. Convertirlo manualmente a COP por gramo según la pureza, cada vez que un cliente pregunta, es lento y propenso a errores.',
        solution: 'La API central consolida varias fuentes, cachea los datos y refresca con un cron automático. Entrega el precio ya convertido a COP por gramo para cada pureza (8K–24K), listo para consultar desde cualquiera de las PWAs.',
        features: [
            'API central con caché, scraping y cron de refresco automático',
            'Precio en COP/gramo según pureza (8K–24K)',
            'Fuentes: goldprice.org, Banco de Bogotá, Netdania, Kitco',
            '3 frontends PWA desplegados en Fly.io',
        ],
        useCases: [
            'Consulta rápida de precio de compra/venta en joyerías',
            'Referencia de cotización para compraventas de oro',
            'Monitoreo de la evolución del precio del metal',
            'Cálculo de valor por gramo según pureza',
        ],
        stack: ['Next.js', 'TypeScript', 'Playwright', 'Firebase', 'Fly.io'],
        tags: ['Next.js', 'TypeScript', 'Playwright', 'Firebase', 'Fly.io'],
        seo: {
            title: 'Monitor Oro & Plata — Cotización en tiempo real en COP/gramo',
            description: 'Sistema de cotización en tiempo real de oro y plata para comerciantes colombianos. API central que scrapea múltiples fuentes y convierte a COP por gramo según pureza (8K–24K).',
        },
    },
    {
        slug: 'tour360',
        name: 'Tour360',
        img: 'tour360.svg',
        status: 'En producción',
        featured: false,
        liveUrl: 'https://tour360-web.fly.dev/',
        tagline: 'Recorridos virtuales 360° que venden por ti',
        pitch: 'Recorridos virtuales 360° que venden por ti. Crea, administra y comparte tours virtuales con tus fotografías 360. Ideal para inmobiliarias, hoteles, museos y más.',
        intro: 'Tour360 es una plataforma para crear, administrar y compartir recorridos virtuales 360°. A partir de tus fotografías panorámicas armas tours interactivos con múltiples escenas que tus clientes recorren desde el navegador, sin instalar nada.',
        problem: 'Una foto plana no transmite un espacio. Coordinar visitas presenciales a cada inmueble, hotel o local cuesta tiempo a ambas partes y filtra mal: mucha gente visita algo que no era lo que buscaba.',
        solution: 'Con un recorrido 360° el cliente explora el espacio completo desde su celular, cuando quiera. Creas el tour con tus fotos, lo gestionas desde un panel y lo compartes con un link listo para enviar por WhatsApp o redes.',
        features: [
            'Visor panorámico 360° interactivo en el navegador',
            'Crea tours con múltiples escenas desde tus fotos 360',
            'Panel de administración para gestionar tus recorridos',
            'Comparte cada tour con un link listo para enviar',
        ],
        useCases: [
            'Recorridos virtuales de inmuebles para inmobiliarias',
            'Muestra de habitaciones e instalaciones de hoteles',
            'Exposiciones y salas virtuales para museos',
            'Presentación de locales, salones y espacios de eventos',
        ],
        stack: ['Tours 360°', 'Node.js', 'React', 'Fly.io'],
        tags: ['Tours 360°', 'Inmobiliarias', 'Hoteles', 'SaaS'],
        seo: {
            title: 'Tour360 — Recorridos virtuales 360° para inmuebles y más',
            description: 'Crea, administra y comparte recorridos virtuales 360° con tus fotografías panorámicas. Visor interactivo en el navegador. Ideal para inmobiliarias, hoteles y museos.',
        },
    },
    {
        slug: 'sunroof-promigas',
        name: 'Sunroof · Promigas',
        img: 'promigas-sunroof.svg',
        status: 'En producción',
        featured: false,
        liveUrl: null,
        tagline: 'Plataforma geoespacial para comercializar predios con potencial solar',
        pitch: 'Plataforma geoespacial para gestión y comercialización de predios con potencial solar. Visualiza polígonos en mapa, cruza datos de contratos y registra ventas en tiempo real.',
        intro: 'Sunroof es una plataforma geoespacial desarrollada para Promigas para gestionar y comercializar predios con potencial solar. Muestra los polígonos de cada predio sobre un mapa interactivo, cruza esa información con los datos de contratos y permite registrar ventas en tiempo real.',
        problem: 'Comercializar predios con potencial solar exige ver dónde están, cuáles están disponibles y qué contrato tiene cada uno. Manejar eso en hojas de cálculo separadas del mapa hace lento el proceso y difícil saber el estado real.',
        solution: 'Un mapa interactivo muestra los polígonos disponibles y vendidos, cruza cada predio con su tabla de contratos y deja registrar la venta directamente sobre el mapa, con popups configurables con la información de cada predio.',
        features: [
            'Mapa interactivo con polígonos disponibles y vendidos',
            'Vista de detalle cruzada con tabla de contratos',
            'Botón para registrar venta en tabla intermedia',
            'Popups configurables con datos del predio',
        ],
        useCases: [
            'Comercialización de predios con potencial de generación solar',
            'Visualización geoespacial del inventario de predios',
            'Cruce de predios con información contractual',
            'Registro y seguimiento de ventas sobre el mapa',
        ],
        stack: ['Leaflet', 'PostGIS', 'Node.js', 'Mapas'],
        tags: ['Leaflet', 'PostGIS', 'Mapas', 'Promigas'],
        seo: {
            title: 'Sunroof · Promigas — Plataforma geoespacial de predios solares',
            description: 'Plataforma geoespacial para gestión y comercialización de predios con potencial solar. Polígonos en mapa interactivo, cruce con contratos y registro de ventas en tiempo real.',
        },
    },
    {
        slug: 'ordenes-campo-promigas',
        name: 'Órdenes de Campo · Promigas',
        img: 'promigas-ordenes.svg',
        status: 'En producción',
        featured: false,
        liveUrl: null,
        tagline: 'Gestión de órdenes de trabajo: app móvil para campo + backoffice',
        pitch: 'Sistema integral de gestión de órdenes de trabajo con app móvil para inspectores y backoffice para administradores. Incluye módulo de proveedores y segmentación de data por usuario.',
        intro: 'Órdenes de Campo es un sistema integral de gestión de órdenes de trabajo desarrollado para Promigas. Combina una app móvil para que los inspectores registren órdenes directamente en campo y un backoffice web donde los administradores gestionan todo el proceso, con módulo de proveedores y segmentación de datos por usuario.',
        problem: 'Cuando las órdenes de trabajo se registran en papel o se coordinan por teléfono, la información llega tarde y fragmentada. El administrador no tiene visibilidad en tiempo real de lo que pasa en campo ni control sobre los proveedores.',
        solution: 'El inspector registra las órdenes desde la app móvil en el sitio; el administrador las ve y gestiona desde el backoffice. Roles diferenciados, módulo de proveedores y segmentación de la data hacen que cada usuario vea solo lo que le corresponde.',
        features: [
            'App móvil para registro de órdenes en campo',
            'Backoffice web con panel de administración',
            'Módulo de registro y gestión de proveedores',
            'Roles diferenciados: inspector / administrador',
        ],
        useCases: [
            'Registro de órdenes de trabajo por inspectores en terreno',
            'Administración centralizada de órdenes desde el backoffice',
            'Gestión y seguimiento de proveedores',
            'Segmentación de la información según el rol del usuario',
        ],
        stack: ['App móvil', 'Backoffice', 'Node.js', 'Proveedores'],
        tags: ['App móvil', 'Backoffice', 'Proveedores', 'Promigas'],
        seo: {
            title: 'Órdenes de Campo · Promigas — App móvil + backoffice',
            description: 'Sistema integral de gestión de órdenes de trabajo con app móvil para inspectores y backoffice para administradores. Módulo de proveedores y segmentación de data por usuario.',
        },
    },
]

module.exports = products
